import classNames from "classnames";
import { useRouterParams } from "components/useRouterParams";
import { useRouter } from "next/router";
import XIcon from "public/svg/x.svg";

import { Filter } from "../GridFilters";

import styles from "./grid-filter-tags.module.scss";

type GridFilterTagsProps = {
    filters: Filter[];
};

export const GridFilterTags = ({ filters }: GridFilterTagsProps) => {
    const router = useRouter();
    const routerParams = useRouterParams({
        method: "push",
        shallow: true,
        scroll: false,
    });

    const returnFilterName = (filterID: string) => {
        let filterName = "";
        let filterOption;

        filters.forEach((filter) => {
            filterOption = filter.options.find(
                (option) => option.id === Number(filterID),
            );
            if (filterOption) {
                filterName = filterOption.option;
            }
        });

        return filterName;
    };

    const onFilterChange = (name: string, value: string) => {
        delete router.query.offset;
        routerParams.toggleParam(name, value);
    };

    const getQueryEntries = () => {
        const queryEntries = [...Object.entries(router.query)];
        return queryEntries.filter(
            (entry) =>
                entry[0] !== "slug" &&
                entry[0] !== "ordering" &&
                entry[0] !== "offset" &&
                entry[0] !== "limit",
        );
    };

    const renderFilters = () => {
        const queryEntries = getQueryEntries();
        let xIcon = <XIcon />;
        if (queryEntries) {
            return queryEntries.map((entry, parentIndex) => {
                const entryValue = entry[1];
                if (entryValue) {
                    if (Array.isArray(entryValue)) {
                        return entryValue.map((entryID, childIndex) => {
                            return (
                                <li
                                    key={childIndex}
                                    onClick={() =>
                                        onFilterChange(entry[0], entryID)
                                    }
                                >
                                    {returnFilterName(entryID)}
                                    {xIcon}
                                </li>
                            );
                        });
                    } else {
                        return (
                            <li
                                key={parentIndex}
                                onClick={() =>
                                    onFilterChange(entry[0], entryValue)
                                }
                            >
                                {returnFilterName(entryValue)}
                                {xIcon}
                            </li>
                        );
                    }
                }
            });
        }

        return null;
    };
    const onClearFilters = () => {
        // Reset all checkboxes
        document
            .querySelectorAll("input[type=checkbox]")
            .forEach((el) => (el.ariaChecked = "false"));

        let queryKeys = [...Object.keys(router.query)];
        queryKeys = queryKeys.filter(
            (key) =>
                key !== "slug" &&
                key !== "ordering" &&
                key !== "offset" &&
                key !== "limit",
        );
        routerParams.clearParams(...queryKeys);
    };
    const hasFilters = getQueryEntries().length > 0;

    return (
        <section>
            <ul
                className={classNames({
                    [styles.emptyFilterList]: !hasFilters,
                    [styles.filterList]: hasFilters,
                })}
            >
                {renderFilters()}
                {hasFilters && (
                    <li className={styles.cta} onClick={onClearFilters}>
                        Clear All
                    </li>
                )}
            </ul>
        </section>
    );
};
